import { PVSUtilStrategy } from '@/models/PVSStrategy.ts';
import { Appointment } from '@/models/appointment/Appointment.ts';
import { UpdateAppointmentDto } from '@/models/appointment/UpdateAppointmentDto.ts';
import { PVSProvider } from '@/models/customers/PVSProvider.ts';
import { DCSchedulePartialUpdateDto } from '@/models/doc-cirrus/DCSchedulePartialUpdateDto.ts';

import { buildDetailsString } from '@/utils/appointmentUtils.ts';

export const doc_cirrus_util_strategy: PVSUtilStrategy = {
    getPvsPatientId: (appointment: Appointment) => appointment.links?.patient_id,
    getScheduleTypeId: (appointment: Appointment) => appointment.links?.schedule_type_id,
    getCalendarId: (appointment: Appointment) => appointment.links?.calendar_id,
    getProfessionalId: (appointment: Appointment) => appointment.links?.practitioner_id,
    getInstanceId: (appointment: Appointment) => appointment.links?.dc_instance_id,
    getRoomId: (appointment: Appointment) => appointment.links?.room_id,
    updateRoomId: (appointment: Appointment, room_id: string): Appointment => {
        // Create a copy of the appointment to avoid mutating the original
        const updated_appointment = { ...appointment };

        // Ensure links object exists
        if (updated_appointment.links) {
            updated_appointment.links = { ...updated_appointment.links, room_id };
        }

        return updated_appointment;
    },

    getUpdatePartialDtoPVSAppointment: (
        update_data: Partial<UpdateAppointmentDto>,
        appointment: Appointment
    ): DCSchedulePartialUpdateDto => {
        const body: DCSchedulePartialUpdateDto = {};

        // Error if not doc cirrus
        if (appointment.pvs_provider !== PVSProvider.DOC_CIRRUS) throw new Error('Appointment is not doc cirrus');

        if (update_data.appointment?.start) body.start = update_data.appointment.start;
        if (update_data.appointment?.duration) body.duration = update_data.appointment.duration.value;

        if (update_data.professional) {
            body.calendar = update_data.professional.calendar_id;
            body.employee = update_data.professional.dc_user_id;
        }

        if (update_data.appointment?.types && update_data.pvs?.doc_cirrus?.schedule_type_id) {
            body.scheduletype = update_data.pvs?.doc_cirrus.schedule_type_id;
        }

        if (update_data.appointment?.room_id !== undefined) body.roomId = update_data.appointment.room_id;
        if (update_data.appointment?.priority) body.severity = update_data.appointment.priority;

        if (update_data.appointment || update_data.professional) {
            body.details = buildDetailsString(
                undefined,
                undefined,
                update_data.appointment?.types ?? appointment.data.services,
                update_data.appointment?.info ?? appointment.data.info,
                undefined,
                update_data.appointment?.ticket,
                undefined,
                update_data.appointment?.is_no_show
            );
        }
        if (update_data.appointment?.description !== undefined) body.userDescr = update_data.appointment.description;

        if (update_data.patient_id) body.patient = update_data.patient_id;

        return body;
    },
};
